// eslint-disable-next-line
import React, { Fragment } from 'react';
import { FaEdit } from 'react-icons/fa';
import { ArcaHttpClientPrice } from '../../../code/ArcaHttpClientPrice';
import { ArcaDate } from '../../../code/Types/ArcaDate';
import { ArcaComponent } from '../../pages/ArcaComponent';
import { PriceEditPanel } from './PriceEditPanel';
import { ArcaHttpSystem } from '../../../code/ArcaHttpSystem';
import { DateWrapper } from '../Datepickers/DateWrapper';


export class PricePanel extends ArcaComponent {

    constructor(props) {
        super(props);

        this.state = {
            prices: null,
            editPrice: null,
            isEdit: false,
            referenceDate: ArcaDate.Today
        };
    }

    async componentDidMount() {
        this.getScreenDetails(this.state.referenceDate)
    }

    getScreenDetails(date) {
        ArcaHttpClientPrice.GetPricesAtDateAsync(
            date,
            ((prices) => this.setState({ prices, referenceDate: date })),
            (msg => alert(msg))
        )
    }

    handleDateChange(e) {

        if (e.target.value === '') {
            return
        }

        var selectedDate = new ArcaDate(new Date(e.target.value))
        this.getScreenDetails(selectedDate)
    }

    onEditClick(p) {
        this.setState({ isEdit: true, editPrice: p })
    }

    render() {
        let { prices, referenceDate, isEdit, editPrice } = this.state;

        return (
            <Fragment>
                <h1 className='centerText'>Price management</h1>
                <h3 className='centerText'>
                    <DateWrapper
                        referenceDate={referenceDate}
                        handleDateChange={(e) => this.handleDateChange(e)} />
                </h3>

                <table className='table table-striped' aria-labelledby="tabelLabel">
                    <thead>
                        <tr>
                            <th>Type</th>
                            {!ArcaHttpSystem.IsSmartphone
                                ? <th>Activity</th> : null}
                            {!ArcaHttpSystem.IsSmartphone
                                ? <th>Currency</th> : null}
                            <th>Cost</th>
                            {!ArcaHttpSystem.IsSmartphone
                                ? <th>Start date</th>
                                : null}
                            <th>End date</th>
                            <th>Edit</th>
                        </tr>
                    </thead>
                    <tbody>
                        {prices ? prices.map((p, k) =>
                            <tr key={k}>
                                <td>{p.ActivityType}</td>
                                {!ArcaHttpSystem.IsSmartphone
                                    ? <td>{p.Name}</td> : null}
                                {!ArcaHttpSystem.IsSmartphone
                                    ? <td>{p.Currency}</td> : null}
                                <td>{p.Value}</td>
                                {!ArcaHttpSystem.IsSmartphone
                                    ? <td>{p.StartDate.ToDateString}</td>
                                    : null}
                                <td>{p.EndDate.ToDateString}</td>
                                <td>
                                    <span
                                        className='minilink'
                                        onClick={this.onEditClick.bind(this, p)} >
                                        <FaEdit size='25px' />
                                        {'   '}Edit
                                    </span>
                                </td>
                            </tr>
                        )
                            : null}
                    </tbody>
                </table>

                {isEdit && editPrice ?
                    <PriceEditPanel
                        price={editPrice}
                        isVisible={isEdit}
                        onChange={() => this.getScreenDetails(referenceDate)}
                        onCancel={() => this.setState({ isEdit: false })}
                    />
                    : null}

            </Fragment>
        );
    }
}